import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class NibrasTitleService extends Title {
  private readonly TITLE_PREFIX = 'Nibras NX'; // Constant application name

  setTitle(subTitle: string): void {
    // Prepend the project name to the page name
    super.setTitle(`${this.TITLE_PREFIX} - ${subTitle}`);
  }
}
